import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { getOptionsFromParams } from 'utils/DropdownUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.cpfsProfessores;
export default function Educadores() {
  const auth = useSelector((stateAuth: RootState) => stateAuth.auth);
  const isUserProfessor =
    auth.userData.perfil === 'pufv_professor' ||
    auth.userData.perfil === 'pufv_professor_gestor';
  const { state, dispatch, validator, loadEducadores } =
    useContext(ProjetosContext);
  const [educadoresNecessarios, setEducadoresNecessarios] = useState<string[]>(
    []
  );
  const isFirstMount = useRef(true);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'cpfsProfessores',
        etapa: EtapaProjeto.infosIniciais,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  const hasPreselectedRef = useRef(false);
  useEffect(() => {
    const fetchData = async () => {
      const result = await loadEducadores(state.projeto.idEscola);
      if (result && result.educadoresNecessarios) {
        setEducadoresNecessarios(result.educadoresNecessarios);
      }
    };
    fetchData();
  }, [loadEducadores, state.projeto.idEscola]);

  useEffect(() => {
    const checkAndExecuteLogic = () => {
      if (isFirstMount.current) {
        isFirstMount.current = false;
        return;
      }
      if (educadoresNecessarios.length === 0 && isUserProfessor) {
        const userEducator = state.options.educadores.options.find(
          (educador) => educador.nome === auth.userData.nome
        );
        if (userEducator && !hasPreselectedRef.current) {
          const currentSelected = state.projeto.cpfsProfessores || [];
          if (!currentSelected.includes(userEducator.cpf)) {
            dispatch({
              type: 'setProjeto',
              payload: {
                cpfsProfessores: [...currentSelected, userEducator.cpf],
              },
            });
            hasPreselectedRef.current = true;
          }
        }
      } else if (educadoresNecessarios.length > 0) {
        loadEducadores(state.projeto.idEscola);
      }
    };
    const timeoutId = setTimeout(checkAndExecuteLogic, 500);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    state.options.educadores.options,
    educadoresNecessarios,
    isUserProfessor,
  ]);

  const options = useMemo(() => {
    return state.options.educadores.options &&
      state.options.educadores.options.length
      ? getOptionsFromParams(state.options.educadores.options, 'cpf', (a) =>
          a.nome.toUpperCase()
        )
      : [];
  }, [state.options.educadores.options]);

  return (
    <Row>
      <Col>
        <NewAutoCompleteField
          disabled={!state.projeto.idEscola || state.disabledFields}
          label={language.label}
          placeholder={language.placeholder}
          loading={state.options.educadores.loading}
          loadingMessage={language.loading}
          options={options}
          value={state.projeto.cpfsProfessores || []}
          multiple
          onChange={(option: { value: string; label: string }[]) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                cpfsProfessores: option?.map((opt) => opt.value) ?? [],
              },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
        />
      </Col>
    </Row>
  );
}
